import React, { useMemo } from 'react';
import { Box, HStack, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { getCertHolderAddressInfo, getContactFromHierarchy } from '../util';

import RequirementBlock from './RequirementBlock';

const CertHolderInfoBlock = ({ company, job, department }) => {
  const addressDetails = useMemo(() => getCertHolderAddressInfo(company, department), [company, department]);
  const contactDetails = useMemo(() => getContactFromHierarchy(company, department, job), [job, department, company]);

  return (
    <RequirementBlock title="Certificate Holder Information">
      <HStack alignItems="flex-start" justifyContent="space-between" spacing={4}>
        <Box>
          <Text textStyle="bodyLg500">Certificate Holder</Text>
          <Text>{addressDetails.name}</Text>
          <Text>{addressDetails.address1}</Text>
          {addressDetails.address2 && <Text>{addressDetails.address2}</Text>}
          <Text>{`${addressDetails.city ? `${addressDetails.city},` : ''} ${addressDetails.state ?? ''} ${addressDetails.zip ?? ''}`}</Text>
        </Box>
        {!!contactDetails.name && (
          <Box>
            <Text textStyle="bodyLg500">Contact</Text>
            <Text>{contactDetails.name}</Text>
            <Text>{contactDetails.email}</Text>
            <Text>{contactDetails.phone}</Text>
          </Box>
        )}
        <Box>
          <Text textStyle="bodyLg500">Project Information</Text>
          <Text>{job.jobName}</Text>
        </Box>
      </HStack>
    </RequirementBlock>
  );
};

CertHolderInfoBlock.propTypes = {
  company: PropTypes.shape({
    companyId: PropTypes.number,
    companyName: PropTypes.string,
    companyAddress1: PropTypes.string,
    companyAddress2: PropTypes.string,
    companyCity: PropTypes.string,
    companyState: PropTypes.string,
    companyZip: PropTypes.string,
    contact: PropTypes.shape({
      userFirstName: PropTypes.string,
      userLastName: PropTypes.string,
      userEmail: PropTypes.string,
      userPhone: PropTypes.string
    })
  }),
  job: PropTypes.shape({
    jobName: PropTypes.string,
    owner: PropTypes.shape({
      userFirstName: PropTypes.string,
      userLastName: PropTypes.string,
      userEmail: PropTypes.string,
      userPhone: PropTypes.string
    })
  }),
  department: PropTypes.shape({
    departmentName: PropTypes.string,
    deptAddress1: PropTypes.string,
    deptAddress2: PropTypes.string,
    deptCity: PropTypes.string,
    deptState: PropTypes.string,
    deptZip: PropTypes.string,
    owner: PropTypes.shape({
      userFirstName: PropTypes.string,
      userLastName: PropTypes.string,
      userEmail: PropTypes.string,
      userPhone: PropTypes.string
    })
  })
};

export default CertHolderInfoBlock;
